import UIFormLabel from 'UIComponents/form/UIFormLabel';
import { ReviewMetadataColumn, ReviewMetadataRow, StyledMetadataValue } from 'automation-ui-canvas/containers/review/StyledMetadataDetails';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UserName from 'automation-ui-references/customer-data/UserName';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpdateMetadata = ({
  flow
}) => {
  var _flow$updateMetadata, _flow$updateMetadata2;
  const userId = flow === null || flow === void 0 || (_flow$updateMetadata = flow.updateMetadata) === null || _flow$updateMetadata === void 0 || (_flow$updateMetadata = _flow$updateMetadata.updatedBy) === null || _flow$updateMetadata === void 0 ? void 0 : _flow$updateMetadata.userId;
  const updatedAt = flow === null || flow === void 0 || (_flow$updateMetadata2 = flow.updateMetadata) === null || _flow$updateMetadata2 === void 0 ? void 0 : _flow$updateMetadata2.updatedAt;
  return /*#__PURE__*/_jsxs(ReviewMetadataRow, {
    children: [/*#__PURE__*/_jsxs(ReviewMetadataColumn, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.detailsStep.update"
        })
      }), /*#__PURE__*/_jsx(StyledMetadataValue, {
        children: updatedAt ? /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
          value: updatedAt,
          hideSeconds: true,
          format: 'lll'
        }) : '--'
      })]
    }), /*#__PURE__*/_jsxs(ReviewMetadataColumn, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.detailsStep.updatedBy"
        })
      }), /*#__PURE__*/_jsx(StyledMetadataValue, {
        children: userId ? /*#__PURE__*/_jsx(UserName, {
          id: userId
        }) : '--'
      })]
    })]
  });
};
export default UpdateMetadata;